const translations = { options: 'Opciones', selectChecklist: 'Selección de cuestionario', checklist: 'Cuestionario' }

export default translations
